import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, AppDispatch } from '../store';
import {CategoryModel} from "../../models/category.model";
import {HttpResponse} from "../../services/http.service";
import axios from "axios";
import {CategoryCsvModel} from "../../models/category-csv.model";
import * as d3 from 'd3-fetch';
import {PaginationModel} from "../../models/pagination.model";
import {toggleLoader} from "../global/global-slice";

const initialState: CategoriesSliceState = {
    categoriesLoaded: false,
    categories: [],
    categoriesCsv: []
};

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        setCategories(state, action: PayloadAction<CategoryModel[]>) {
            state.categoriesLoaded = true;
            state.categories = action.payload;
        },
        setCsvCategories(state, action: PayloadAction<CategoryCsvModel[]>) {
            state.categoriesCsv = action.payload;
        }
    }
});

export const loadCategories = (): AppThunk => async (dispatch: AppDispatch) => {
    const res: HttpResponse<PaginationModel<CategoryModel[]>> = await axios.get('category/?offset=0&limit=-1');

    if (res.data && res.data.results) {
        dispatch(categoriesSlice.actions.setCategories(res.data.results));
    }
}

export const loadCsvCategories = (): AppThunk => async (dispatch: AppDispatch) => {
    const res = await d3.csv('/data/kategorie-thema3.csv', data => data);
    dispatch(categoriesSlice.actions.setCsvCategories(res));
}

export default categoriesSlice.reducer;

export interface CategoriesSliceState {
    categoriesLoaded: boolean;
    categories: CategoryModel[];
    categoriesCsv: CategoryCsvModel[];
}
